import { render, staticRenderFns } from "./AppEmployeeStatsSelectColumnsDlg.vue?vue&type=template&id=5f1233f0&scoped=true&"
import script from "./AppEmployeeStatsSelectColumnsDlg.vue?vue&type=script&lang=js&"
export * from "./AppEmployeeStatsSelectColumnsDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1233f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
